import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get, union, merge, filter, isFunction } from 'lodash'
import { Link } from 'react-router-dom'

import { PageWrapper } from 'Components/Layout/Page/PageWrapper'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { FilterBox } from 'Components/Filter/FiltersWrapper/box'
import { MultiSelectCustom } from '../../Components/Filter/MultiselectCustom'
import { FiltersWrapper } from 'Components/Filter/FiltersWrapper'
import { SearchInput } from 'Components/Header/SearchInput'
import { Table } from 'Components/Table'
import { Td } from 'Components/Table/Td'
import { Th } from 'Components/Table/Th'
import { Tr } from 'Components/Table/Tr'
import { ButtonAdd } from 'Components/Buttons/ButtonAdd'
import { Chip } from 'material-ui'
import { Box, Button } from '@material-ui/core'

export default class FilteredTable extends Component {
  state = {
    searchTerm: null,
    filters: {},
    sortColumn: null,
    sortReverse: false,
    normalizedData: [],
    filterOptions: {},
  }

  componentDidMount() {
    this.setState(() => ({
      ...this.normalizeData(
        this.props.data,
        this.props.columns,
        this.props.keyExtractor,
        this.props.filters,
      ),
      ...this.setDefaultValues(),
    }))
  }

  componentWillReceiveProps(newProps) {
    this.setState(() => ({
      ...this.normalizeData(
        newProps.data,
        newProps.columns,
        newProps.keyExtractor,
        newProps.filters,
      ),
      ...this.setDefaultValues(),
      orderBy: null,
      sortBy: null,
      searchTerm: null,
    }))
  }

  render() {
    return (
      <PageWrapper>
        <LayoutDashboard>
          {this.props.filterComponent && this.props.filterComponent}
          {!this.props.filterComponent && this.renderFilters()}
        </LayoutDashboard>
        <Table>
          {this.renderTableHead()}
          {this.renderTableBody()}
        </Table>
      </PageWrapper>
    )
  }

  setDefaultValues = () =>
    filter(this.props.filters, 'defaultValue')
      .map(({ columnName, defaultValue }) => this.setFilters(defaultValue)())
      .reduce(merge, null)

  // TODO: filter with term based on all fields in columns
  searchHandler = searchTerm => {
    this.setState(
      state => {
        return {
          ...state,
          searchTerm,
        }
      },
      () => this.props.onSearch(this.state.searchTerm),
    )
  }

  changeSort = columnName => {
    this.setState(state => {
      return {
        ...state,
        sortColumn: columnName,
        sortReverse: state.sortColumn === columnName && !state.sortReverse,
      }
    })
  }

  getFilterValue = (name, index) => {
    var val = this.state.filterOptions[name][index]
    if (val && typeof val === 'object') return val.value
    return val
  }

  setFilters = defaultValue => ({ name, value } = {}) => ({
    ...this.state,
    filters: {
      ...this.state.filters,
      [name]: defaultValue || value,
    },
  })

  // TODO: just set the filter on state, creating a object with all selected filters
  changeFilter = name => (evt, index, value) => {
    if (this.props.onFilterValueChange) {
      this.props.onFilterValueChange(name, value)
    }
    const newState = this.setFilters()({ name, value })
    this.setState(newState)
  }

  filterData = (items, filters) => {
    let data

    if (filters.countryCode && filters.countryCode.includes('All')) data = items
    else
      data = items.filter(item =>
        filters.countryCode.includes(item.countryCode),
      )

    const filteredData = data.sort((a, b) => {
      const countryCodeA = a.countryCode
      const countryCodeB = b.countryCode

      return countryCodeA > countryCodeB
        ? 1
        : countryCodeA < countryCodeB
        ? -1
        : 0
    })

    return this.state.sortReverse ? filteredData.reverse() : filteredData
  }

  normalizeData = (items, columns, keyExtractor, filters) => {
    const getAcessor = column => {
      return isFunction(column.accessor)
        ? column.accessor
        : item => get(item, column.accessor)
    }

    const normalizeItem = item => {
      return columns.reduce(
        (resultItem, column) => {
          return {
            ...resultItem,
            [column.name]: getAcessor(column)(item),
          }
        },
        { key: keyExtractor(item) },
      )
    }

    const filterOptions = {}

    let filtersWithNoOptionsDefined = []

    var stateFilters = this.state.filters

    filters.forEach(filter => {
      if (filter.options) {
        filterOptions[filter.columnName] = [null, ...filter.options]
      } else {
        filtersWithNoOptionsDefined.push(filter)
      }
      if (filter.value !== undefined) {
        stateFilters = {
          ...stateFilters,
          [filter.columnName]: filter.value,
        }
      }
    })

    this.setState({ filters: stateFilters })

    const normalizedData = items.reduce((result, item) => {
      const nItem = normalizeItem(item)

      Object.keys(nItem).map(columnName => {
        const baseFilter = filtersWithNoOptionsDefined.find(
          f => f.columnName === columnName,
        )

        if (baseFilter && nItem[columnName]) {
          filterOptions[columnName] = union(
            filterOptions[columnName] || [null],
            [nItem[columnName]],
          )
        }

        return true
      })

      result.push(nItem)
      return result
    }, [])

    return {
      normalizedData,
      filterOptions,
    }
  }

  renderFilters = () => {
    const {
      filters,
      onButtonAddHandler,
      showSearchFilter,
      searchLabel,
    } = this.props
    const userCountry = this.props.user.countryCode

    const dropdownFilters = filters.map(filter => {
      const options = (this.state.filterOptions[filter.columnName] || []).map(
        value => {
          if (value && typeof value === 'object') {
            var label = value.label
            var val = value.value
          }

          return {
            value: val || value,
            label: label || value || filter.noValueLabel,
          }
        },
      )
      const onCleanCountries = () => {
        this.props.setSelectedCountries([userCountry])
      }

      return (
        <Box display="flex" flexDirection="column" position="relative">
          <MultiSelectCustom
            key={`select-${filter.columnName}`}
            className={`select-${filter.columnName}`}
            hasPrimaryText={false}
            label={filter.label}
            onChange={this.changeFilter(filter.columnName)}
            options={options}
            value={this.state.filters[filter.columnName] || null}
            autoWidth={options.length > 0 ? filter.autoWidth : false}
            sorted={filter.sorted}
            ASC={filter.ASC}
            selectedCountries={this.props.selectedCountries}
            setSelectedCountries={this.props.setSelectedCountries}
            userCountry={userCountry}
          />
          {this.props.selectedCountries.length >= 2 && (
            <Button
              style={{
                position: 'absolute',
                top: '50px',
                left: '60px',
                textTransform: 'none',
                fontSize: 14,
                fontFamily: "'Proxima Nova', sans-serif",
                color: '#273754',
                fontWeight: '700',
                minWidth: 80,
                backgroundColor: '#F9F9FF',
                borderRadius: '4px',
              }}
              size="small"
              onClick={() => onCleanCountries()}
            >
              Clear all
            </Button>
          )}
        </Box>
      )
    })

    return (
      <FiltersWrapper className="filters-wrapper">
        <FilterBox className="filter-box">
          {showSearchFilter && (
            <SearchInput
              className="search-input"
              placeholder={searchLabel}
              searchHandler={this.searchHandler}
              value={this.state.searchTerm}
            />
          )}
        </FilterBox>
        <FilterBox dropdowns className="filter-box">
          {dropdownFilters}
          {onButtonAddHandler && (
            <ButtonAdd
              className="button-add"
              onClickHandler={onButtonAddHandler}
            />
          )}
          <Box
            style={{
              width: '600px',
              height: '100px',
              overflow: 'hidden',
              display: 'flex',
              flexWrap: 'wrap',
            }}
          >
            {this.props.selectedCountries.map(item => {
              if (item === 'All') {
                return null
              }
              return (
                <Chip
                  size={'small'}
                  style={{
                    marginLeft: 14,
                    borderRadius: 4,
                    border: `1px solid #E2E2FC`,
                    fontSize: 16,
                    fontFamily: "'Proxima Nova', sans-serif",
                    color: '#011533',
                    backgroundColor: '#E2E2FC',
                    marginBottom: '10px',
                    height: '35px',
                  }}
                  label={item}
                  onRequestDelete={() => {
                    const country = this.props.selectedCountries.filter(
                      selectedCountry => selectedCountry !== item,
                    )
                    if (!country || country.length === 0) {
                      return this.props.setSelectedCountries([
                        this.props.user.countryCode,
                      ])
                    }
                    this.props.setSelectedCountries(country)
                  }}
                >
                  {item}
                </Chip>
              )
            })}
          </Box>
        </FilterBox>
      </FiltersWrapper>
    )
  }

  renderTableHead = () => {
    const tableHeadColumns = this.props.columns.map(column => {
      const cellProps = {
        className: `column-${column.name} ${column.class || ''}`,
        key: column.name,
      }

      if (column.sortable) {
        cellProps.className = `sortable ${cellProps.className}`
        cellProps.onClick = () => this.changeSort(column.name)
      }
      return <Th {...cellProps}>{column.label}</Th>
    })

    return (
      <thead>
        <Tr>{tableHeadColumns}</Tr>
      </thead>
    )
  }

  renderTableBody = () => {
    const filteredData = this.filterData(
      this.state.normalizedData,
      this.state.filters,
    )

    const rowsJSX = filteredData.map(row => {
      return this.renderTableRow(row)
    })

    return (
      <tbody>
        {rowsJSX}
        {this.getFooterRows()}
      </tbody>
    )
  }

  renderTableRow = row => {
    const TdWrapper = ({ isAction, children }) =>
      this.props.redirectNamespace && !isAction ? (
        <Link
          className="invisible-link"
          to={`${this.props.redirectNamespace}/${row.key}`}
        >
          {children}
        </Link>
      ) : (
        children
      )

    const cellsJSX = this.props.columns.map((column, index) => {
      const key = `${row.key}-${index}`
      const value = column.render
        ? column.render(row[column.name], row)
        : row[column.name]
      return (
        <Td
          key={key}
          actions={column.type === 'actions'}
          className={`column-${column.name} ${column.class || ''}`}
        >
          <TdWrapper isAction={column.type === 'actions'}>
            {value || ''}
          </TdWrapper>
        </Td>
      )
    })

    return <Tr key={row.key}>{cellsJSX}</Tr>
  }

  getFooterRows = () => {
    const { footerRows } = this.props
    return footerRows
  }
}

FilteredTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      accessor: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.array,
        PropTypes.func,
      ]).isRequired,
      sortable: PropTypes.bool,
      render: PropTypes.func,
    }),
  ).isRequired,
  keyExtractor: PropTypes.func,
  filterComponent: PropTypes.node,
  filters: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      noValueLabel: PropTypes.string,
      columnName: PropTypes.string,
      options: PropTypes.array,
    }),
  ),
  createRoute: PropTypes.string,
  onSearch: PropTypes.func,
  searchLabel: PropTypes.string,
  showSearchFilter: PropTypes.bool,
  onButtonAddHandler: PropTypes.func,
}

FilteredTable.defaultProps = {
  filterComponent: null,
  keyExtractor: item => item.id,
  filters: [],
  onSearch: term => console.warn('onSearch not implemented', term),
  searchLabel: 'Search anything',
  showSearchFilter: true,
}
